<template>
	<div class="">
		<v-header ref="dudu"></v-header>
		<div class="beijngsd">
			<span></span>
			个人中心
			<span></span>
		</div>
		<div class="manpin">
			<div class="main centen container">
				<leftmenu></leftmenu>
				<div class="main_r">
					<div class="info">
						<div class="title">
							<img src="../images/user/line.png" alt=""> 我的选科
						</div>
						<!-- 俩按钮 -->
						<div class="select">
							<div class="item" :class="{active:ates == index }" v-for="(item,index) in qiehuan" @click="qiehuansde(index)">{{item.text}}</div>
						</div>
						<!-- 切换内容 智能选科-->
						<div class="" v-if="ates == 0">
							<div class="detail">
								<div class="item1">
									<div class="l">
										<span class="bold">省市：</span>
										<span class="text">河北省邯郸市</span>
										<span class="bold">类型：</span>
										<span class="text">理科</span>
									</div>
									<div class="r">
										创建时间：2021-11-21 12:21:10
									</div>
								</div>
								<div class="item2">
									<div>
										<span class="bold">专业：</span>
										<span class="text">经济与金融、金融学</span>
									</div>
								</div>
								<div class="item3">
									<div>
										<span class="bold">测评结果：</span>
										<span class="text">评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容</span>
									</div>
								</div>
							</div>
							<div class="chart">
								<div class="title">
									<div class="l">选考科目及对应可报专业情况</div>
									<div class="r">
										<div class="item1"><div></div>	人数</div>
										<div class="item2"><div></div>	比例</div>
									</div>
								</div>
								<result></result>
							</div>
						</div>
						<!-- 切换内容 测评选科-->
						<div class="" v-if="ates == 1">
							<div class="detail">
								<div class="item1">
									<div class="l">
										<span class="bold">省市：</span>
										<span class="text">河北省邯郸市</span>
										<span class="bold">类型：</span>
										<span class="text">理科</span>
									</div>
									<div class="r">
										创建时间：2021-10-16 12:21:10
									</div>
								</div>
								<div class="item2">
									<div>
										<span class="bold">专业：</span>
										<span class="text">经济与金融、玄学</span>
									</div>
								</div>
								<div class="item3">
									<div>
										<span class="bold">测评结果：</span>
										<span class="text">评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容评价内容</span>
									</div>
								</div>
							</div>
							<div class="chart">
								<div class="title">
									<div class="l">选考科目及对应可报专业情况</div>
									<div class="r">
										<div class="item1"><div></div>	人数</div>
										<div class="item2"><div></div>	比例</div>
									</div>
								</div>
								<result></result>
							</div>
						</div>
					</div>
				</div>



			</div>
		</div>


		<item7></item7>
	</div>
</template>

<script>
	import vHeader from '../../components/vHeader.vue'
	import item7 from '../../components/item7.vue'
	import leftmenu from '../../components/leftmenu.vue'
	import toast from '../../components/toast.vue'
	export default {
		name: "",
		components: {
			vHeader,
			item7,
      leftmenu,
			toast
		},
		data() {
			return {
				options: [],
				value: '',
				radio: '1',
				radio2:"1",
				duichu:false,
				dusnhhwe:true,
				qiehuan:[
					{text:"智能选科"},
					{text:"测评选科"},
				],
				ates:0,

				// 手机号!/^1[3456789]\d{9}$/.test(this.dinahua)
			}
		},

		methods: {

			qiehuansde(index){
				this.ates = index
			},

  }

	}
</script>

<style scoped="scoped" >
	/* 退出登录 */
	.tuichuden{ width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;position: fixed;top: 0;left: 0;background: rgba(0,0,0,0.8);}
	.annou{display: flex;flex-direction: column;width: 380px;height: 229px;background: rgba(255, 255, 255, 1);opacity: 1;border-radius: 20px;padding: 0 21px;box-sizing: border-box;}
	.annou h1{width: 100%;height: 48px;font-size: 20px;font-family: PingFang SC;font-weight: 500;color: #29A7E1;opacity: 1;display: flex;align-items: center;border-bottom: 1px solid rgba(0, 0, 0, 0.1);}
	.annou p{ width: 100%;display: flex;align-items: center;justify-content: center;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #666666;flex: 1;}
	.annou dl{width: 100%;display: flex;align-items: center;justify-content: space-between;}
	.annou dl dt{cursor: pointer; width: 140px;height: 46px;background: rgba(200, 200, 200, 1);opacity: 1;border-radius: 23px;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #666666;display: flex;align-items: center;justify-content: center;}
	.annou dl dd{cursor: pointer;width: 140px;height: 46px;background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);box-shadow: 0px 0px 10px #F53824;opacity: 1;border-radius: 24px;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #FFFFFF;display: flex;align-items: center;justify-content: center;}




	.beijngsd {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100px;
		background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
		background-size: 100% 100%;
		font-size: 28px;
		font-family: Microsoft YaHei;
		font-weight: 400;
    margin-top: 70px;
		color: #FFFFFF;
	}

	.beijngsd span {
		display: flex;
		width: 44px;
		height: 2px;
		opacity: 0.48;
		border-radius: 1px;

		background-color: #FFFFFF;
	}

	.beijngsd span:nth-of-type(1) {
		margin-right: 14px;
	}

	.beijngsd span:nth-of-type(2) {
		margin-left: 14px;
	}

	.centen {
		width: 1280px;
		margin: 0 auto;
	}

	.manpin {
		width: 100%;
		height: auto;
		padding: 40px 0;
		box-sizing: border-box;
		background: #ebeef5d6;
	}

	.main {
		padding-bottom: 40px;
		display: flex;
		justify-content: space-between;
	}

	.main_l {
		background: rgba(251, 251, 251, 1);
		width: 210px;
	}

	.topxiang {
		width: 100%;
		height: 194px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: rgba(255, 255, 255, 1);
		border-radius: 5px;
		margin-bottom: 30px;
	}

	.topxiang img {
		width: 102.73px;
		height: 102.73px;
		margin-bottom: 20px;
	}

	.topxiang span {
		width: 144px;
		height: 22px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		opacity: 1;
	}

	.jibenxinxi {
		width: 290px;
		height: 700px;
		background: rgba(255, 255, 255, 1);
		opacity: 1;
		border-radius: 5px;
	}

	.jibenxinxi figure {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.jibenxinxi figure img {
		height: 44px;
		margin-left: 22px;
	}

	.jibenxinxi figure figcaption {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #666666;
		margin-left: 10px;
	}

	.beijngsdtu {
		background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
		background-size: 100% 100%;
	}

	.texts {
		color: #F53824 !important;
	}

	.xiaoxi {
		margin-left: 10px;
		background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
		background-size: 100% 100%;
		width: 33px;
		height: 23px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}

	.main_r {
		width: 1050px;
		height: 878px;
		background: rgba(255, 255, 255, 1);
		opacity: 1;
		border-radius: 5px;
		padding: 20px;
		box-sizing: border-box;
	}

	.mainr_top {
		width: 100%;
		height: 68px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
	}

	.mainr_top img {
		width: 7px;
		height: 24px;
		margin-right: 10px;
	}

	.youxinxi {
		padding: 33px 20px 0 20px;
		width: 310px;
		height: 230px;
		background: rgba(253, 251, 247, 1);
		border: 1px solid #FBF5E9;
		opacity: 1;
		border-radius: 5px;
		position: absolute;
		top: 24px;
		right: 20px;
	}

	.mainr_bot {
		width: 100%;
		position: relative;
	}

	.youxinxi label {
		position: absolute;
		top: -14px;
		left: 20px;
		width: 92px;
		height: 28px;
		background: rgba(244, 166, 65, 1);
		opacity: 1;
		border-radius: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}

	.youxinxi figure {
		display: flex;
		margin-bottom: 13px;
	}

	.youxinxi figure img {
		margin-right: 4px;
		width: 18px;
		height: 20px;
	}

	.youxinxi figure figcaption {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #5A4F40;
	}

	.form {
		width: auto;
		height: auto;
		display: flex;
		flex-direction: column;
		margin-top: 30px;
		margin-left: 40px;
	}

	.form li {
		width: auto;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		position: relative;
	}

	.form li label {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		width: 80px;
		text-align: right;
	}

	.form li i {
		color: #F53824;
		margin: 0 5px;
	}

	.form li input {
		width: 372px;
		height: 40px;
		background: rgba(255, 255, 255, 0.39);
		border: 1px solid #E0E0E0;
		opacity: 1;
		border-radius: 5px;
		padding: 0 10px;
		box-sizing: border-box;

	}

	.duanxin {
		border: none;
		position: absolute;
		top: 5px;
		left: 240px;
		width: 120px;
		height: 30px;
		background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
		opacity: 1;
		border-radius: 2px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}

	.duanxin2{
		border: none;
		position: absolute;
		top: 5px;
		left: 240px;
		width: 120px;
		height: 30px;
		background: rgba(238, 238, 238, 1);
		opacity: 1;
		border-radius: 2px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #999999;
	}
	.shoujiinp{width: auto; display: flex;position: relative;}
	.form li{position: static;}
	/* .form li .shoujiinp input{width: auto;} */
	.form li .shoujiinp span{margin-top: 5px;}

	.form li span {
		margin-left: 5px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #F53824;
		opacity: 1;
	}
	.inps{width: 118px;height: 40px;}
	.inps:nth-of-type(1){margin-right: 9px;}
	.inps:nth-of-type(2){margin-right: 9px;}
	.inpda{width: 372px;height: 40px;background: rgba(255, 255, 255, 0.39);opacity: 1;}
	.baochuan{border: none;margin-left: 115px;margin-top: 20px; width: 140px;height: 46px;background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);opacity: 1;border-radius: 23px;display: flex;align-items: center;justify-content: center;font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #FFFFFF;}

	@media (min-width:750px) {
		.mainr_bot2{display: none;}
	}
	@media (max-width:750px) {
		.mainr_bot{display: none;}
		.beijngsd{height: 70px;font-size: 24px;}
		.main{flex-direction: column;}
		.main_l{width: 100%;}
		.jibenxinxi::-webkit-scrollbar{display: none;}
		.manpin{padding: 20px 0;}
		.topxiang{flex-direction: row;width: 100%;height: auto;justify-content: revert;margin-bottom: 15px;}
		.topxiang span{margin-left: 20px;}
		.topxiang img{margin: 0;height: 60px;width: 60px;}
		.jibenxinxi{width: 100%;height: auto; display: flex; flex-direction: row;overflow-y: hidden;overflow: auto;    background: whitesmoke;}
		.jibenxinxi figure{flex-shrink: 0;width: auto;margin: 0 5px;}
		.beijngsdtu {
			/* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
			background:none;
			/* background-size: 100% 100%; */
			border-bottom: 1px solid #F53824;
		}
		.jibenxinxi figure img{margin-left: 0;}

		.youxinxi2 {
			padding: 33px 20px 0 20px;
			width: 100%;
			height: 230px;
			background: rgba(253, 251, 247, 1);
			border: 1px solid #FBF5E9;
			opacity: 1;
			border-radius: 5px;
			position: relative;
		}

		.mainr_bot2 {
			width: 100%;
			margin-top: 20px;
			/* position: relative; */
		}

		.youxinxi2 label {
			position: absolute;
			top: -14px;
			left: 20px;
			width: 92px;
			height: 28px;
			background: rgba(244, 166, 65, 1);
			opacity: 1;
			border-radius: 14px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
		}

		.youxinxi2 figure {
			display: flex;
			margin-bottom: 13px;
		}

		.youxinxi2 figure img {
			margin-right: 4px;
			width: 18px;
			height: 20px;
		}

		.youxinxi2 figure figcaption {
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: 500;
			color: #5A4F40;
		}
		.main_r{width: 100%;display: flex;flex-direction: column;}


		.form{margin-left: 0;}
		.shoujiinp{flex: 1;display: flex;flex-direction: column;position: relative;}
		.form li{position: static;}
		.form li .shoujiinp input{width: auto;}
		.form li .shoujiinp span{margin-top: 5px;}
		.form li label{flex-shrink: 0;}

		.duanxin{right: 10px;left: auto;top: 5px;width: 85px;border-radius:5px ;font-size: 10px;}
		.duanxin2{right: 10px;left: auto;top: 5px;width: 85px;border-radius:5px ;font-size: 10px;}
	}



	.title{color: #333333;font-size: 16px;line-height: 18px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);padding-bottom:15px;}
		 .title>img{width: 5px;height: 18px;margin-right: 10px;}
		 .select{display: flex;margin: 15px 0px 20px 0px;}
		 .select>.item{width: 160px;height: 32px;margin: 0px 10px;line-height: 32px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);cursor: pointer;font-weight: bold;color: #333333;}
		 .select>.active{background-color: #FFD6D2;color: #F53824;}

		 .detail{padding: 10px;border: 1px solid rgba(0, 0, 0, 0.10);border-radius: 5px;box-sizing: border-box;}
		 .detail>div{margin: 10px 0px;}
		 .detail>.item1{display: flex;justify-content: space-between;flex-wrap: wrap;}
		 .detail>.item1>.l>.bold{font-weight: bold;color: #333333;font-size: 12px;}
		 .detail>.item1>.l>.text{color: #666666;font-size: 12px;margin-right: 10px;}
		 .detail>.item1>.r{color: #999999;font-size: 12px;}
		 .detail>.item2{}
		 .detail>.item2>div>.bold{font-weight: bold;color: #333333;font-size: 12px;}
		 .detail>.item2>div>.text{color: #666666;font-size: 12px;margin-right: 80px;}
		 .detail>.item3{}
		 .detail>.item3>div{display: flex;}
		 .detail>.item3>div>.bold{font-weight: bold;color: #333333;font-size: 12px;flex-shrink: 0;}
		 .detail>.item3>div>.text{color: #666666;font-size: 12px;}

		 .chart{margin-top: 30px;}
		 .chart>.title{display: flex;justify-content: space-between;flex-wrap: wrap;}
		 .chart>.title>.l{color: #29A7E1;font-size: 12px;}
		 .chart>.title>.r{display: flex;}
		 .chart>.title>.r>div{display: flex;font-size:12px ;color: #333333;align-items: center;}
		 .chart>.title>.r>div>div{width: 30px;height: 16px;border-radius: 5px;margin-right: 6px;}
		 .chart>.title>.r>.item1{margin-right: 6px;}
		 .chart>.title>.r>.item1>div{background-color: #29A7E1;}
		 .chart>.title>.r>.item2>div{background-color: #FE9603;}
		 .chart>.content{width: 100%;height: 421px;}






		.title{
      width: 100%;
      height: 68px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;


      /* color: #333333;font-size: 20px;line-height: 24px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);padding-bottom:20px; */
      }
		.title>img{width: 7px;height: 24px;margin-right: 10px;}
		.select{display: flex;margin: 20px 0px 30px 0px;}
		.select>.item{width: 180px;height: 42px;margin: 0px 10px;line-height: 42px;text-align: center;border-radius: 5px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);cursor: pointer;font-weight: bold;color: #333333;}
		.select>.active{background-color: #FFD6D2;color: #F53824;}

		.detail{height: 151px;padding: 20px;border: 1px solid rgba(0, 0, 0, 0.10);border-radius: 5px;box-sizing: border-box;}
		.detail>div{margin: 8px 0px;}
		.detail>.item1{display: flex;justify-content: space-between;}
		.detail>.item1>.l>.bold{font-weight: bold;color: #333333;font-size: 16px;}
		.detail>.item1>.l>.text{color: #666666;font-size: 16px;margin-right: 80px;}
		.detail>.item1>.r{color: #999999;}
		.detail>.item2{}
		.detail>.item2>div>.bold{font-weight: bold;color: #333333;font-size: 16px;}
		.detail>.item2>div>.text{color: #666666;font-size: 16px;margin-right: 80px;}
		.detail>.item3{}
		.detail>.item3>div{display: flex;}
		.detail>.item3>div>.bold{font-weight: bold;color: #333333;font-size: 16px;flex-shrink: 0;}
		.detail>.item3>div>.text{color: #666666;font-size: 16px;}

		.chart{margin-top: 30px;}
		.chart>.title{display: flex;justify-content: space-between;}
		.chart>.title>.l{color: #29A7E1;font-size: 20px;}
		.chart>.title>.r{display: flex;}
		.chart>.title>.r>div{display: flex;font-size:16px ;color: #333333;align-items: center;}
		.chart>.title>.r>div>div{width: 36px;height: 20px;border-radius: 5px;margin-right: 6px;}
		.chart>.title>.r>.item1{margin-right: 50px;}
		.chart>.title>.r>.item1>div{background-color: #29A7E1;}
		.chart>.title>.r>.item2>div{background-color: #FE9603;}
		.chart>.content{width: 100%;height: 421px;}

</style>



// WEBPACK FOOTER //
// src/views/mine/g_wdxuanke1.vue